import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, startSession, isAdvisor, BOOKING_HOST } from "@/lib/tracker";

export const VisitorTracker = () => {
  const loc = useLocation();

  useEffect(() => { startSession(); }, []);

  useEffect(() => {
    if (isAdvisor() || loc.pathname.startsWith("/admin")) return;
    const t = setTimeout(() => track("page", { path: loc.pathname, label: document.title }), 80);
    return () => clearTimeout(t);
  }, [loc.pathname]);

  useEffect(() => {
    let last = Date.now();
    let acc = 0;
    const flush = (beacon = false) => {
      if (acc >= 1000) { track("time", { time_ms: acc, beacon }); acc = 0; }
    };
    const tick = () => {
      if (document.visibilityState === "visible") acc += Date.now() - last;
      last = Date.now();
      if (acc >= 15000) flush();
    };
    const iv = setInterval(tick, 5000);
    const onHide = () => { tick(); flush(true); };
    const onClick = (e) => {
      const a = e.target?.closest?.("a[href]");
      if (a && a.href && a.href.includes(BOOKING_HOST)) track("booking_click", { meta: { href: a.href } });
    };
    document.addEventListener("visibilitychange", onHide);
    window.addEventListener("pagehide", onHide);
    document.addEventListener("click", onClick, true);
    return () => {
      clearInterval(iv);
      document.removeEventListener("visibilitychange", onHide);
      window.removeEventListener("pagehide", onHide);
      document.removeEventListener("click", onClick, true);
      flush(true);
    };
  }, []);

  return null;
};
